import React from 'react';

import { ProfileModel } from '@pukka/api';
import * as Tooltip from '@radix-ui/react-tooltip';
import sortBy from 'lodash/sortBy';

interface OutletTooltipsProps {
  readonly children: React.ReactNode;
  readonly outlets: ProfileModel.Outlet[];
  readonly totalOutlets: number;
}

function OutletTooltip({ children, outlets, totalOutlets }: OutletTooltipsProps) {
  const sortedOutlets = sortBy(outlets, 'name');

  return (
    <Tooltip.Provider delayDuration={300}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <span>{children}</span>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content className="w-48 overflow-auto rounded bg-white text-sm shadow-md" sideOffset={5}>
            <div className="bg-neutral-200 px-3 py-1.5 text-neutral-700">Assigned Outlet</div>
            <ul className="list-disc py-2.5 pl-6 text-sm text-neutral-700">
              {sortedOutlets.map((outlet, index) => (
                <li className="py-1" key={index}>
                  {outlet.name}
                </li>
              ))}
              {totalOutlets > 10 && <span className="pt-1 font-medium">{totalOutlets - 10} others</span>}
            </ul>
            <Tooltip.Arrow className="h-2 w-2 fill-neutral-200" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}

export { OutletTooltip };
